
import addDays from 'date-fns/addDays'
import format from 'date-fns/format'
import isFutureDateFns from 'date-fns/isFuture'
import toTitleCase from './toTitleCase'
interface DateTimeFormatOptions {
  localeMatcher?: 'lookup' | 'best fit';
  weekday?: 'long' | 'short' | 'narrow';
  era?: 'long' | 'short' | 'narrow';
  year?: 'numeric' | '2-digit';
  month?: 'numeric' | '2-digit' | 'long' | 'short' | 'narrow';
  day?: 'numeric' | '2-digit';
  hour?: 'numeric' | '2-digit';
  minute?: 'numeric' | '2-digit';
  second?: 'numeric' | '2-digit';
  timeZoneName?: 'long' | 'short';
  formatMatcher?: 'basic' | 'best fit';
  hour12?: boolean;
  timeZone?: string; // this is more complicated than the others, not sure what I expect here
}

export const getFormatedTime = (d: Date, locale?: string) => {
  //return something like 23:03 or 06:11
  const date = new Date(d)
  return date.toLocaleTimeString([locale ? locale : "he"], { hour: '2-digit', minute: '2-digit', hour12: false })
}

export const getFormatedDate = (d: Date, locale: string) => {
//return something like מחר | יום שני, 15.3.2021 | היום
  const today = new Date().toLocaleDateString([locale ? locale : "he"])
  const tomorrow = new Date(addDays(new Date(), 1)).toLocaleDateString([locale ? locale : "he"])
  const yesterday = new Date(addDays(new Date(), -1)).toLocaleDateString([locale ? locale : "he"])
  const date = new Date(d)
  const dateStr = date.toLocaleDateString([locale ? locale : "he"])
  const rtf = new Intl.RelativeTimeFormat([locale ? locale : "he"], { numeric: "auto" });
  
  let options: DateTimeFormatOptions = { weekday: 'long', month: 'numeric', year: 'numeric', day: 'numeric' };

  
  if (today === dateStr) {
    return toTitleCase(rtf.format(0, "day"))
  }
  if(tomorrow === dateStr){
    return toTitleCase(rtf.format(1, "day"))
  }
  if(yesterday === dateStr){
    return toTitleCase(rtf.format(-1, "day"))
  }
  return date.toLocaleDateString([locale ? locale : "he"], options)
}
export const getFormatedDuration = (milliseconds: number):string => {
  //return something like 1:32 or 0:35
  const minutes = milliseconds / 1000 / 60;
  if (minutes < 60) {
    return `${minutes}`
  } else {
    let h = parseInt("" + minutes / 60)
    let m: string | number = minutes % 60
    m = m < 10 ? `0${m}` : m
    return `${h}:${m}`
  }
}
export const getDuration = (d1: Date, d2: Date) => {
  return new Date(d2).getTime() - new Date(d1).getTime();
}
export const formatDate = (date: Date) => {
  // return format(new Date(date), 'yyyy-MM-dd')
  return format(new Date(date), 'dd.MM.yyy')
}

export const formatViewLessonDate = (date: Date) => {
  // return format(new Date(date), 'yyyy/MM/dd')
  return format(new Date(date), 'dd/MM/yyy')
}

export const getDayAfter = (date: Date) => {
  return format(addDays(date, 1), 'yyyy-MM-dd')
}
export const getDayBefore = (date: Date) => {
  return format(addDays(date, -1), 'yyyy-MM-dd')
}
export const isToday = (d: Date) => {
  const date = new Date(d.toString()).toDateString()
  const today = new Date().toDateString()
  return (date === today)? true : false
}
export const isDateExpired = (d: Date, limit:number) => {
  //limit - a milliseconds unit
  const date = d.getTime()
  const now = new Date().getTime()
  return ((now - date) > limit )? true : false
}
export const addSubtractTime = (date: Date, offset:number, unit:string) => {
  //return FormatedTime something like 23:03 or 06:11
  if(unit==="m"){
    //Offset can be minus
    offset=offset*60*1000
  }
  if(unit==="h"){
    //Offset can be minus
    offset=offset*60*60*1000
  }
  return getFormatedTime(new Date(date.getTime()+offset))
}

export const isFuture = (date: Date): boolean => isFutureDateFns(date);

export const getFormatedMinutes = (divider?:number):string=>{
  //If divider supplied then the function can return specific minutes value.
  //For example divider===15 can return 00 or 15 or 30  
  let m = new Date().getMinutes()
  if(divider){
      if(divider>60) throw "Divider:maximum value is 60"
      m = Math.round(m/divider) * divider
      return m < 10 ? `0${m}` : (m===60? '00' : ``+m)
  }else{    
    return m < 10 ? `0${m}` : ``+m
  }
}
export const getMinutesByDevider = (divider:number) => {
  if(divider>60) throw "Divider:maximum value is 60"
  let m = new Date().getMinutes()
  m = Math.round(m/divider) * divider
  if(m===60) return 0
  return m
}

export const getFormatedHour = (divider?:number)=>{
  //If divider supplied then the function can return specific hours value.
  //For example divider===4 can return 00 or 04 or 08 or 12 or 16 ...
  let h = new Date().getHours()
  if(divider){
    if(divider>24) throw "Divider:maximum value is 24"
    h = Math.round(h/divider) * divider
    return h<10? `0${h}` : h===24? '00' : ``+h
  }else{
    return h<10? `0${h}` : ``+h
  }
}

export const getYearsRange = (start:number, end:number, step?:number):number[] => {
  let years = []
  while (start <= end) {
    years.push(start)
    start += (step || 1)
  }
  return years;
}

export const getMonthList = (locale = "en", format: "long" | "short" = "long") =>
Array.from(
  Array(12).keys(),
  key => Intl.DateTimeFormat(locale, {
    month: format
  })
  .format(new Date(0, key))
);

export {addDays} 

export const isPast = (d: Date) => {
  const thirtyOneMiutesMS = 1860000
  return isDateExpired(d, thirtyOneMiutesMS)
}